import styles from './App.module.css';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation
} from 'react-router-dom'
import Landing from './views/Landing'
import SignUp from './views/SignUp';
import TaskList from './views/TaskList'
import NewTaskApp from './views/NewTaskApp';
import NewTaskData from './views/NewTaskData'
import NewTaskDataV2 from './views/NewTaskDataV2'
import NewTaskDevice from './views/NewTaskDevice'
import NewTaskTrain from './views/NewTaskTrain'
import TaskDetail from './views/TaskDetail'
import NamespaceSettingGeneral from './views/NamespaceSettingGeneral'
import ProtectRoute from './compoenets/ProtectRoute';
import Sidebar from './compoenets/Sidebar';
import Header from './compoenets/Header';
import ModelCatalog from './views/ModelCatalog';
import ModelDetail from './views/ModelDetail';
import Callback from './views/Callback';
import ModelUpload from './views/ModelUpload';
import Experiment from './views/Experiment';

const ROUTER=[
  { path:'callback', element:<Callback/>},
  { path:'sign-up', element:<SignUp/>},
  { path:'task-list', element:<TaskList/>},
  { path:'new-task-app', element:<NewTaskApp/>},
  { path:'new-task-data', element:<NewTaskData/>},
  { path:'new-task-data-v2', element:<NewTaskDataV2/>},
  { path:'new-task-device', element:<NewTaskDevice/>},
  { path:'new-task-train', element:<NewTaskTrain/>},
  { path:'task-detail', element:<TaskDetail/>},
  { path:'task-detail/:taskId', element:<ProtectRoute><TaskDetail/></ProtectRoute>},
  { path:'model-catalog', element:<ModelCatalog/>},
  { path:'model-detail', element:<ModelDetail/>},
  { path:'model-detail/:modelId', element:<ProtectRoute><ModelDetail/></ProtectRoute>},
  { path:'model-upload', element:<ModelUpload/>},
  { path:'namespace-setting-general', element:<NamespaceSettingGeneral/>},
  { path:'experiment', element:<Experiment/>},
  // { path:'*', element:<PageNotFound/>},
]

export default function App() {
  const location = useLocation();

  return (
    <div className={styles['App']}>
      {location.pathname !== '/' && location.pathname !== '/sign-up' && location.pathname !== '/callback'&&<>
      <Header className={styles['header']}/>
      <Sidebar className={styles['sidebar']}/>
      </>}
      <div className={`${styles['main']} ${(location.pathname === '/' || location.pathname === '/sign-up') && styles['landing']}`}>
        <Routes>
          <Route index element={<Landing/>} />
          {ROUTER.map(({path,element})=>(
            <Route path={path} element={element}></Route>
          ))}
        </Routes>
      </div>
    </div>
  );
}